import { BloodPressureRiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<BloodPressureRiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [
        BloodPressureRiskLevel.Hypotension,
        [
          { code: 'systolic', upper: 90 },
          { code: 'diastolic', upper: 60 },
        ],
      ],
      [
        BloodPressureRiskLevel.Normal,
        [
          { code: 'systolic', lower: 90, upper: 120 },
          { code: 'diastolic', lower: 60, upper: 80 },
        ],
      ],
      [
        BloodPressureRiskLevel.Elevated,
        [
          { code: 'systolic', lower: 120, upper: 130 },
          { code: 'diastolic', lower: 60, upper: 80 },
        ],
      ],
      [
        BloodPressureRiskLevel.Hypertension1,
        [
          { code: 'systolic', lower: 130, upper: 140 },
          { code: 'diastolic', lower: 80, upper: 90 },
        ],
      ],
      [
        BloodPressureRiskLevel.Hypertension2,
        [
          { code: 'systolic', lower: 140, upper: 180 },
          { code: 'diastolic', lower: 90, upper: 120 },
        ],
      ],
      [
        BloodPressureRiskLevel.HypertensionCrisis,
        [
          { code: 'systolic', lower: 180 },
          { code: 'diastolic', lower: 120 },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
